module.exports = __webpack_public_path__ + "static/media/bg-pic-recog.80d9c463.jpg";